import { Button, Checkbox } from "antd";
import styled from "styled-components";
export const MyButton = styled(Button)`
  background: #000000;
  border-radius: 10px;
  border: none;
  height: unset;

  font-weight: 500;
  font-size: 16px;
  line-height: 17px;
  text-align: center;
  color: #ffffff;

  &:focus,
  &:hover {
    color: #ffffff;
    background: #000000;
    opacity: .9;
  }
  &.confirm {
    background: #000;

    box-shadow: none;
    color: #ffffff;
    opacity: 1;
    weight: 500;
    &:hover {
      opacity: .9;
      background: #000;
    }
  }
  &.primary {
    background: #000;
    color: #ffffff;
    &:hover {
      opacity: .9;
      background: #000;
    }
  }
  width: ${(props) => props.width ?? 170}px;
  height: ${(props) => props.height ?? 52}px;
  &[disabled] {
    opacity: 0.5;
    pointer-events: none;
  }
  @media (max-width: 1024px) {
    font-size: 14px;
    line-height: 17px;
    width: 280px;
    height: 50px;
  }
`;

export const MyCheckBox = styled(Checkbox)`
  & .ant-checkbox-inner {
    width: 24px;
    height: 24px;
  }
  & .ant-checkbox-checked {
    & .ant-checkbox-inner {
      border: none;
      background: #000;
      &::after {
        width: 6.714286px;
        height: 14.142857px;
        top: 47%;
        left: 28.5%;
      }
    }
  }
`;
